var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2347.2,4831.1c-442.6-42.7-881.7-223.5-1225.4-503.2c-101.5-81.9-261.8-244-342-344.7 c-203.9-255.6-371.4-601.1-440.8-911.1c-43.6-194.1-53.4-289.4-53.4-512.1c0-222.6,9.8-317.9,53.4-512.1 c70.4-316.2,242.2-667,453.3-926.2c81.9-101.5,244-261.8,344.7-342C1392.5,575.9,1738,408.4,2048,339 c194.1-43.6,289.4-53.4,512.1-53.4c222.6,0,317.9,9.8,512.1,53.4c232.4,51.7,537,181.7,737.4,314.4 c346.4,230.7,612.7,533.5,795.3,904.8c111.3,227.1,174.6,431,214.6,690.2c21.4,143.4,21.4,480,0,623.4 c-40.1,259.2-103.3,463.1-214.6,690.2c-119.3,242.2-252,427.5-443.5,616.3c-187.9,186.1-359.8,308.1-599.4,425.7 c-224.4,110.4-432.8,175.4-681.3,213.7C2768.5,4834.6,2463.9,4841.8,2347.2,4831.1z M2791.6,3472.9v-227.1h-231.6h-231.6v227.1 V3700h231.6h231.6V3472.9z M2789.8,2104.1l1.8-684h-231.6h-231.6v679.5c0,374,2.7,683.1,6.2,686.6c3.6,2.7,106,4.5,228.9,3.6 l223.5-2.7L2789.8,2104.1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.262d02d1322c8bcf6e8b192ea0582460.svg";
export { ForwardRef as ReactComponent };